import React from 'react';
import { LinkList } from '../ui/link-list/LinkList';
import { PrenavLink } from '../prenav-link/PrenavLink';
import type { Link } from '../types';

import styles from './top-links.scss';

interface TopLinksProps {
  links: Link[];
}

export const TopLinks = ({ links }: TopLinksProps) => (
  <LinkList
    links={links}
    Item={PrenavLink}
    className={styles.links}
    children={undefined}
  />
);
